import axiosInstance from '../axiosInstance';

export async function getGameMarketValue(name, platform) {
  const params = { name };
  if (platform) params.platform = platform;
  const response = await axiosInstance.get('/cex/game/value', { params });
  return response.data;
}

export async function getConsoleMarketValue(name) {
  const response = await axiosInstance.get('/cex/console/value', { params: { name } });
  return response.data;
}

export async function updateGamePrice(itemId, marketValue) {
  const price = `CEX: £${marketValue.sellPrice} (Buy) / £${marketValue.cashPrice} (Sell)`;
  const { data: game } = await axiosInstance.get(`/games/${itemId}`);
  await axiosInstance.put(`/games/${itemId}`, { ...game, price });
}

export async function updateConsolePrice(itemId, marketValue) {
  const price = `CEX: £${marketValue.sellPrice} (Buy) / £${marketValue.cashPrice} (Sell)`;
  const { data: console_ } = await axiosInstance.get(`/consoles/${itemId}`);
  await axiosInstance.put(`/consoles/${itemId}`, { ...console_, price });
}
